import React, { Component } from 'react'
import {Alert,Row,Col,Table,Input,Button,Spinner} from 'reactstrap'
import {connect } from 'react-redux';
import {getMainData} from "../../Redux/ducks/mainReducer";
import {datesDiffe} from "../../GeneralFunctions/general"
import {Redirect} from 'react-router-dom';

export class ExpiredLoans extends Component {
    state={
        isLoading:false,
        msg:null,
        mainData:null,
        searchAction:null,
        nameSearch:null,
        redirect:false,
        redirectSelectedID:null,
        searchLimit:"1",
    }

    componentDidMount(){
        this.setState({isLoading:true})
        this.props.getMainData("EXPIRED_LOAND")
    }

    componentDidUpdate(prevProps){
        const{userData,msg,userDataStatus} = this.props;
        if(userDataStatus !== prevProps.userDataStatus){
            if(userDataStatus===true){
                this.setState({isLoading:false,msg:msg,mainData:userData})
            }else{
                this.setState({isLoading:false,mainData:null,msg:null})
            }
        }
    }

    viewUser=(e)=>{
        this.setState({
            redirect:true,
            redirectSelectedID:e.target.id
        })
    }

    setValue = e =>{
        this.setState({[e.target.name]:e.target.value})
    }

    setSearchValue = (e) =>{
        this.setState({nameSearch:e.target.value,searchAction:e.target.id})
    }

    getDaysPassed = (loan) =>{
        const currentDate = this.state.mainData?.currentDate || new Date()
        return (datesDiffe(currentDate,loan.endDate,null)+1)*-1
    }

    renderLoanRow = (values,myNo,i) => (
        <tr key={i}>
            <td>{myNo}</td>
            <td><Button id={values.userID} onClick={this.viewUser}>View Details</Button></td>
            <th scope="row">{values.loanID}</th>
            <td>{values.member.firstName+" "+values.member.lastName}</td>
            <td>{values.member.clubNumber}</td>
            <td>{this.getDaysPassed(values)}</td>
            <td>{values.paytype == null? "": values.paytype.name}</td>
            <td>{values.entryDate}</td>
            <td>{values.endDate}</td>
            <td>{values.period}</td>
            <td>{values.rate}</td>
            <td>{values.amount}</td>
            <td>{values.amountExpected}</td>
            <td>{values.amountPaid}</td>
            <td>{values.loanBalance}</td>
            <td>{Math.round(values.amount / values.period)}</td>
            <td>{values.details}</td>
            <td>{values.created_at}</td>
        </tr>
    )

    render() {
        const { redirect,redirectSelectedID,mainData,nameSearch,searchAction,searchLimit } = this.state;
        if (redirect) {
            return <Redirect to={{pathname:"/see_clients", state:{redirectSelectedID:redirectSelectedID}}}/>
        }

        let expiredLoanDataList = [];
        let myNo = 0

        if(mainData !== null){
            const loanData = mainData.loanData
            if(loanData.length>0){
                loanData.forEach((values, i) =>{
                    const hasSearch = nameSearch !== null && nameSearch !== ""
                    const memberName = (values.member.firstName+" "+values.member.lastName).toUpperCase()
                    const daysPassed = this.getDaysPassed(values)
                    const matchesLoan = searchAction ==="LOANID" && values.loanID === nameSearch.toUpperCase()
                    const matchesName = searchAction ==="NAME" && memberName.includes(nameSearch.toUpperCase())
                    const matchesAccount = searchAction ==="ACCOUNT" && values.member.clubNumber === nameSearch.toUpperCase()
                    const matchesDays = searchAction ==="MODE" && (
                        parseInt(searchLimit)===1
                            ? parseInt(daysPassed) === parseInt(nameSearch)
                            : parseInt(daysPassed) <= parseInt(nameSearch)
                    )

                    if(!hasSearch || matchesLoan || matchesName || matchesAccount || matchesDays){
                        myNo = myNo+1
                        expiredLoanDataList.push(this.renderLoanRow(values,myNo,i))
                    }
                });
            }else{
                expiredLoanDataList.push(
                    <tr key="empty">
                        <td colSpan="18"><br/><Alert color="primary">No expired loans found</Alert></td>
                    </tr>
                )
            }
        }

        return (
            <div>
                <Row className="mainWrraper">
                    <div className="block-header">
                        <h4>VIEW EXPIRED LOANS</h4>
                    </div>
                    <Col xs="12" className="mainWrraper2" >
                        <div className='table-container'>
                            <Table striped responsive>
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Details</th>
                                        <th>Loan ID</th>
                                        <th>Member</th>
                                        <th>Member No.</th>
                                        <th>Days Passed</th>
                                        <th>Loan Type</th>
                                        <th>Entry Date</th>
                                        <th>End Date</th>
                                        <th>Period(Month)</th>
                                        <th>Rate(%)</th>
                                        <th>Loan Amount</th>
                                        <th>Amount Expected</th>
                                        <th>Amount Paid</th>
                                        <th>Loan Balance</th>
                                        <th>Installment</th>
                                        <th>Comment</th>
                                        <th>Date</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th><Input type="text" className="account" onChange={this.setSearchValue} value={this.state.searchAction ==="LOANID" ?this.state.nameSearch:null} id="LOANID"/></th>
                                        <th><Input type="text" className="clientName" onChange={this.setSearchValue} value={this.state.searchAction ==="NAME" ?this.state.nameSearch:null} id="NAME"/></th>
                                        <th><Input type="text" className="account" onChange={this.setSearchValue} value={this.state.searchAction ==="ACCOUNT" ?this.state.nameSearch:null} id="ACCOUNT"/></th>
                                        <th>
                                            <Input type="select" onChange={this.setValue} name="searchLimit">
                                                <option value="1">Exact Days</option>
                                                <option value="2">Selected Days & Below</option>
                                            </Input>
                                            <Input type="text" className="account2" onChange={this.setSearchValue} value={this.state.searchAction ==="MODE" ?this.state.nameSearch:null} id="MODE"/>
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                {this.state.isLoading?
                                <tbody>
                                    <tr>
                                        <td colSpan="18">
                                            <Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Loading...'}
                                        </td>
                                    </tr>
                                </tbody>:
                                <tbody>
                                    {expiredLoanDataList}
                                </tbody>}
                            </Table>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    userDataStatus : state.mainReducer.dataStatus,
    msg : state.mainReducer.msg,
    userData : state.mainReducer.mainData,
});

export default connect(
    mapStateToProps,
    {getMainData}
)(ExpiredLoans)
